import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import './VolunteerActivityLog.css'
import LoadingScreen from '../components/LoadingScreen'

const VolunteerActivityLog = () => {
  const history = useHistory()
  const [activities, setActivities] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')

  useEffect(() => {
    fetchActivityLog()
  }, [])

  const fetchActivityLog = async () => {
    try {
      const token = localStorage.getItem('access_token')
      const response = await fetch('/api/volunteer/activity-log', {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      })

      if (response.ok) {
        const data = await response.json()
        setActivities(data.activities || [])
      } else {
        setError('Failed to load activity log')
      }
    } catch (err) {
      setError('Network error')
    } finally {
      setLoading(false)
    }
  }

  if (loading) {
    return <LoadingScreen message="Loading Activity Log" />
  }

  return (
    <div className="volunteer-activity-log-container">
      <header className="page-header">
        <h1>Activity Log</h1>
        <button onClick={() => history.push('/volunteer-dashboard')}>← Back</button>
      </header>

      <main className="activity-log-main">
        {error && <div className="error-message">{error}</div>}

        <div className="activity-timeline">
          {activities.length > 0 ? (
            activities.map((activity, index) => (
              <div key={index} className="activity-item">
                <div className="activity-icon">📌</div>
                <div className="activity-content">
                  <p className="activity-description">{activity.description}</p>
                  {activity.details && <p className="activity-details">{activity.details}</p>}
                  <span className="activity-time">
                    {new Date(activity.timestamp).toLocaleString()}
                  </span>
                </div>
              </div>
            ))
          ) : (
            <p className="no-activities">No activities found</p>
          )}
        </div>
      </main>
    </div>
  )
}

export default VolunteerActivityLog

